import { h } from 'preact';
import { SelectEntry } from '../entries/SelectEntry';

const getFireTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'timer', label: i18n['opt.Timer'] || 'Timer' },
  { value: 'signal', label: i18n['opt.Signal'] || 'Signal' },
  { value: 'completing', label: i18n['opt.completing'] || 'Completing' },
  { value: 'withdrawing', label: i18n['opt.withdrawing'] || 'Withdrawing' },
  { value: 'approving', label: i18n['opt.approving'] || 'Approving' },
  { value: 'rejecting', label: i18n['opt.rejecting'] || 'Rejecting' },
];

const getMethodTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'webapi', label: i18n['opt.webapi'] || 'WebAPI' },
  { value: 'email', label: i18n['opt.email'] || 'Email' },
  { value: 'sms', label: i18n['opt.sms'] || 'SMS' },
  { value: 'script', label: i18n['opt.script'] || 'Script' },
];

const TASK_TYPES = ['epx:UserTask', 'epx:ServiceTask', 'epx:ScriptTask'];

export class ActionPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return TASK_TYPES.includes(elementType);
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;
    const actions = props.actions || [{}];
    const action = actions[0] || {};

    const update = (key, value) => {
      const updatedActions = [{ ...action, [key]: value }];
      lf.setProperties(id, { actions: updatedActions });
      lf.emit('node:properties-change', { id, properties: { actions: updatedActions } });
    };

    return [
      {
        id: 'action',
        label: i18n.action || 'Action',
        entries: [
          {
            id: 'fireType',
            component: () => (
              <SelectEntry
                id="epx-fireType"
                label={i18n.fireType || 'Fire Type'}
                value={action.fireType || ''}
                options={getFireTypes(i18n)}
                onChange={(val) => update('fireType', val)}
              />
            ),
          },
          {
            id: 'methodType',
            component: () => (
              <SelectEntry
                id="epx-methodType"
                label={i18n.methodType || 'Method Type'}
                value={action.methodType || ''}
                options={getMethodTypes(i18n)}
                onChange={(val) => update('methodType', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
